import { Button } from "components/DesignSystem/Button/Button";
import { LockedButton } from "components/DesignSystem/Button/LockedButton";
import { CustomReportsGrids } from "components/Reports/CustomReports/CustomReportsGrids";
import { useCustomReports } from "components/Reports/CustomReports/useCustomReports";
import { ChatArrowGrow } from "components/icons/ChatArrowGrow";
import { LockedUi } from "components/LockedUi/LockedUi";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useHistory, useRouteMatch } from "react-router-dom";

const OtherReportCard = ({
  title,
  onClick,
}: {
  title: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    className="all:unset t-box-border t-flex t-cursor-pointer t-items-center t-rounded-lg t-border t-border-solid t-border-neutral-10 t-p-4 sm:t-px-3 t-gap-3 t-transition-shadow hover:t-shadow-light-60 t-w-full"
    onClick={onClick}
  >
    <div className="t-flex t-items-center t-justify-center t-min-w-10 t-w-10 t-h-10 t-rounded-full t-shrink-0 t-border t-border-solid t-border-purple-30 t-bg-purple-10 t-ring-4 t-ring-purple-50/5 t-text-purple-50">
      <ChatArrowGrow />
    </div>
    <span className="t-text-subtext t-text-text-60">{title}</span>
  </button>
);

export const OthersLanding = () => {
  const { url } = useRouteMatch();
  const history = useHistory();
  const { link } = useConstructInternalLink();
  const customReports = useCustomReports();

  const baseUrl = url.replace("/others", "");

  const reports = [
    { title: "AR Aging", to: `${baseUrl}/aging-summary` },
    { title: "AP Aging", to: `${baseUrl}/ap-aging` },
    { title: "Vendor Summary", to: `${baseUrl}/vendor-summary` },
    { title: "General Ledger", to: "/books/categories" },
    { title: "Trial Balance", to: "/books/trial-balance" },
  ];

  return (
    <div className="t-flex t-flex-col t-gap-6 t-px-5 sm:t-px-3">
      <div className="t-grid t-grid-cols-2 t-gap-4 sm:t-grid-cols-1">
        {reports.map((report) => (
          <OtherReportCard
            key={report.title}
            title={report.title}
            onClick={() => history.push(link(report.to))}
          />
        ))}
      </div>
      <div className="t-flex t-flex-col t-gap-3">
        <div className="t-flex t-items-center t-justify-between t-gap-2">
          <div className="t-text-subtext t-text-text-60">Custom reports</div>
          <LockedUi
            feature={WRITE_PERMISSION_KEYS.FINANCIALS}
            blockedUi={<LockedButton text="Create new" />}
          >
            <Button
              size="small"
              customType="primary"
              onClick={customReports.handleCreateNew}
              isLoading={customReports.isCreating}
            >
              Create new
            </Button>
          </LockedUi>
        </div>
        <CustomReportsGrids {...customReports} />
      </div>
    </div>
  );
};
